import { GearIcon, StarIcon } from "@primer/octicons-react";
import { Box, UnderlineNav } from "@primer/react";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NguonBietToiPage from "../crm-category/dm_nguonbiettoi";
import NguonBietToiTypePage from "./dm_nguonbiettoi_type";

const NguonBietToiLayout = () => {
    const { tab } = useParams();
    const navigate = useNavigate();
    const selectedTab = useMemo(() => {
        if (tab === "type") return "type";
        return "source"
    }, [tab])
    return (
        <Box>
            <UnderlineNav aria-label="tabs">
                <UnderlineNav.Item icon={StarIcon} aria-current={selectedTab === "source" ? "page" : undefined}
                    onClick={() => {
                        navigate(`../../nguon_biet_toi/source`);
                    }}
                >Nguồn biết tới</UnderlineNav.Item>
                <UnderlineNav.Item icon={GearIcon} aria-current={selectedTab === "type" ? "page" : undefined}
                    onClick={() => {
                        navigate(`../../nguon_biet_toi/type`);
                    }}
                >Loại nguồn</UnderlineNav.Item>
            </UnderlineNav>
            <Box>
                {selectedTab === "source" &&
                    <NguonBietToiPage />
                }
                {selectedTab === "type" &&
                    <NguonBietToiTypePage />
                }
            </Box>
        </Box>
    );
};

export default NguonBietToiLayout;